// extracted by mini-css-extract-plugin
export default {"modalBox":"PDFModal_modalBox__19SQ4","pdf":"PDFModal_pdf__UYV2e","closeBox":"PDFModal_closeBox__5txQZ","closeButton":"PDFModal_closeButton__wd5fQ"};